@import 'styles/mixins';
@import 'styles/blaze/mixins';

.designLoadingPreview {
  border-radius: 20px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;
  max-width: 630px;
  width: 100%;

  div {
    aspect-ratio: var(--aspect-ratio);
  }
}
